<div [@routerTransition]="'fly'">

  <div class="filter-toolbar">
    <div fxLayout="row"
         fxLayoutAlign="space-between center"
         class="table-top">
      <ifc-filters-active-list class="layout margin-sm"
                               [filters]="activeFilters"
                               (filterRemoved)="activeFilterRemoved($event)">
      </ifc-filters-active-list>
      <div fxHide.xs
           class="layout padding-right-md">
        <button mat-icon-button
                (click)="openFilterDialog()"
                matTooltip="Filter">
          <mat-icon>filter_list</mat-icon>
        </button>
        <button *ngIf="readWriteCompetitors"
                routerLink="/admin/competitors/new"
                mat-icon-button
                matTooltip="Add">
          <mat-icon>add_circle</mat-icon>
        </button>
      </div>
      <div fxHide
           fxShow.xs>
        <button mat-icon-button
                [matMenuTriggerFor]="actionsMenu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #actionsMenu="matMenu">
          <button mat-menu-item
                  (click)="openFilterDialog()">
            <mat-icon>filter_list</mat-icon>
            <span>Filter</span>
          </button>
          <button mat-menu-item
                  routerLink="/admin/competitors/new">
            <mat-icon>add_circle</mat-icon>
            <span>Add</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </div>

  <ifc-app-scroll-container [tabbed]="true">
    <div class="table-container">
      <div class="message-box info"
           *ngIf="!data.competitorListResult?.totalCount"
           fxLayout="row"
           fxLayoutGap="12px"
           fxLayoutAlign="start center">
        <mat-icon class="icon">info</mat-icon>
        <span>No data found</span>
      </div>
      <table class="table"
             *ngIf="data.competitorListResult?.totalCount"
             mat-table
             matSort
             [dataSource]="data.competitorListResult.values"
             (matSortChange)="queryWithFilter($event)"
             aria-describedby="competitor list">
        <ng-container matColumnDef="name">
          <th mat-header-cell
              *matHeaderCellDef
              mat-sort-header="name"> Name </th>
          <td mat-cell
              *matCellDef="let row"
              routerLink="/admin/competitors/{{row.id}}"
              class="table-cell"> {{row.name}}
          </td>
        </ng-container>

        <ng-container matColumnDef="active">
          <th mat-header-cell
              *matHeaderCellDef
              mat-sort-header="active"> Status </th>
          <td mat-cell
              *matCellDef="let row"
              routerLink="/admin/competitors/{{row.id}}"
              class="table-cell">
            {{row.active ? 'Active' : 'Inactive'}}
          </td>
        </ng-container>

        <ng-container matColumnDef="apiName">
          <th mat-header-cell
              *matHeaderCellDef
              mat-sort-header="apiName"> Api name </th>
          <td mat-cell
              *matCellDef="let row"
              routerLink="/admin/competitors/{{row.id}}"
              class="table-cell"> {{row.apiName}}
          </td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th mat-header-cell
              *matHeaderCellDef
              mat-sort-header="description"> Description </th>
          <td mat-cell
              *matCellDef="let row"
              routerLink="/admin/competitors/{{row.id}}"
              class="table-cell"> {{row.description}}
          </td>
        </ng-container>

        <ng-container matColumnDef="address">
          <th mat-header-cell
              *matHeaderCellDef> Address </th>
          <td mat-cell
              *matCellDef="let row"
              routerLink="/admin/competitors/{{row.id}}"
              class="table-cell">
            {{ row.address | address }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions"
                      stickyEnd>
          <th mat-header-cell
              *matHeaderCellDef
              mat-sort-header="actions"
              style="width: 50px;"> </th>
          <td mat-cell
              *matCellDef="let row"
              routerLink="/admin/competitors/{{row.id}}">
            <button mat-icon-button
                    class="action-icon">
              <mat-icon>edit</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row
            *matHeaderRowDef="tableColumns"
            class="table-header"></tr>
        <tr mat-row
            *matRowDef="let row; columns: tableColumns;"
            class="clickable-row"></tr>
      </table>
    </div>
  </ifc-app-scroll-container>

  <div [hidden]="data.competitorListResult?.totalCount <= 10">
    <mat-paginator class="paginator"
                   #paginator
                   showFirstLastButtons
                   [length]="data.competitorListResult?.totalCount"
                   [pageSizeOptions]="[10, 20, 50]"
                   (page)="queryWithFilter()">
    </mat-paginator>
  </div>

</div>
